export const LISTA_ESTADOS = [
    'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'
];

export const MASCARA_CPF = [
    /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/
];

export const MASCARA_CNPJ = [
    /[A-Za-z0-9]/, /[A-Za-z0-9]/, '.', /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '.', /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '/', /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '-', /\d/, /\d/
];

export const MASCARA_CEP = [
    /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/
];

export const MASCARA_TELEFONE = [
    '(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/
];

export const MASCARA_DATA = [
    /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/
];
